import React from "react";
import { MessageCircle } from "lucide-react";
import useSiteContact, { whatsappLink } from "../hooks/useSiteContact";

export default function WhatsAppButton() {
  const c = useSiteContact();
  const link = whatsappLink(c);
  if (!link) return null;
  return (
    <a
      href={link}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-float-button"
      className="fixed bottom-6 right-6 z-40 bg-[#25D366] hover:bg-[#1ebe5d] text-white shadow-lg rounded-full w-14 h-14 flex items-center justify-center transition-transform hover:scale-105"
      aria-label="Chat on WhatsApp"
    >
      <MessageCircle size={26} />
    </a>
  );
}
